




















import { Component, Vue, Watch } from 'vue-property-decorator'
import NavComponent from '@/components/NavComponent.vue'
import Breadcrumb from '@/components/breadcrumb.vue'

@Component({
  components: {
    NavComponent,
    Breadcrumb
  }
})
export default class App extends Vue {
  routeLoaded = false

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange (newVal: any) {
    // If currentRoute has name this means route is loaded and we can show breadcrumbs
    if (newVal.name) {
      this.routeLoaded = true
    }
  }
}
